interface I_dateData{
  days: number
  hours: number
  minutes: number
  value: number
}
export const bannerSliderCountdowns = (): void => {
  const allSlides = document.querySelectorAll('.js-bannerSlider-slide') as unknown as HTMLElement[]
  allSlides.forEach(slide => {
    engageCountdowns(slide)
  })
}
const engageCountdowns = (slide: HTMLElement): void => {
  const slideCounterWrapper = slide.querySelector('.js-sliderCounter') as unknown as HTMLElement

  if (!slideCounterWrapper) {
    return
  }

  const setDateData = (countdownData: I_dateData) => {
    const formattedMinutes = (countdownData.minutes.toString().length === 1)
      ? '0' + countdownData.minutes.toString()
      : countdownData.minutes.toString()

    const formattedHours = (countdownData.hours.toString().length === 1)
      ? '0' + countdownData.hours.toString()
      : countdownData.hours.toString()

    const formattedDays = (countdownData.days.toString().length === 1)
      ? '0' + countdownData.days.toString()
      : countdownData.days.toString()

    if (el_days_hundreds) {
      el_days_hundreds.textContent = formattedDays[0]
      el_days_tens.textContent = formattedDays[1]
      el_days_singles.textContent = formattedDays[2]
    } else {
      el_days_tens.textContent = formattedDays[0]
      el_days_singles.textContent = formattedDays[1]
    }

    el_hours_tens.textContent = formattedHours[0]
    el_hours_singles.textContent = formattedHours[1]
    el_minutes_tens.textContent = formattedMinutes[0]
    el_minutes_singles.textContent = formattedMinutes[1]
  }

  // @ts-ignore
  const targetDate = slideCounterWrapper.dataset.targetDate as string

  // @ts-ignore

  const el_days_hundreds = slideCounterWrapper.querySelector('.js-sliderCounter-days-hundreds') as unknown as HTMLElement
  const el_days_tens = slideCounterWrapper.querySelector('.js-sliderCounter-days-tens') as unknown as HTMLElement
  const el_days_singles = slideCounterWrapper.querySelector('.js-sliderCounter-days-singles') as unknown as HTMLElement
  const el_hours_tens = slideCounterWrapper.querySelector('.js-sliderCounter-hours-tens') as unknown as HTMLElement
  const el_hours_singles = slideCounterWrapper.querySelector('.js-sliderCounter-hours-singles') as unknown as HTMLElement
  const el_minutes_tens = slideCounterWrapper.querySelector('.js-sliderCounter-minutes-tens') as unknown as HTMLElement
  const el_minutes_singles = slideCounterWrapper.querySelector('.js-sliderCounter-minutes-singles') as unknown as HTMLElement

  const currentSecondsPassed = (60 - parseInt(new Date().toJSON().substring(17, 19))) * 1000

  let countdownData = null as unknown as I_dateData

  // @ts-ignore
  countdownData = countdown(new Date(targetDate), null, 28) as I_dateData
  setDateData(countdownData)

  setTimeout(() => {
    // @ts-ignore
    countdownData = countdown(new Date(targetDate), null, 28) as I_dateData
    setDateData(countdownData)
    setInterval(() => {
      // @ts-ignore
      countdownData = countdown(new Date(targetDate), null, 28) as I_dateData
      setDateData(countdownData)
    }, 60000)
  }, currentSecondsPassed)
}
